import _defineProperty from "/buddy/remotehvac-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { operationUnit } from '../../style';
import { genStyleHooks } from '../../theme/internal';
import { getCopyableStyles, getEditableStyles, getEllipsisStyles, getLinkStyles, getResetStyles, getTitleStyles } from './mixins';
var genTypographyStyle = function genTypographyStyle(token) {
  var componentCls = token.componentCls,
    titleMarginTop = token.titleMarginTop;
  return _defineProperty({}, componentCls, Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    color: token.colorText,
    wordBreak: 'break-word',
    lineHeight: token.lineHeight
  }, "&".concat(componentCls, "-secondary"), {
    color: token.colorTextDescription
  }), "&".concat(componentCls, "-success"), {
    color: token.colorSuccess
  }), "&".concat(componentCls, "-warning"), {
    color: token.colorWarning
  }), "&".concat(componentCls, "-danger"), {
    color: token.colorError,
    'a&:active, a&:focus': {
      color: token.colorErrorActive
    },
    'a&:hover': {
      color: token.colorErrorHover
    }
  }), "&".concat(componentCls, "-disabled"), {
    color: token.colorTextDisabled,
    cursor: 'not-allowed',
    userSelect: 'none'
  }), "\n        div&,\n        p\n      ", {
    marginBottom: '1em'
  }), getTitleStyles(token)), _defineProperty(_defineProperty({}, "\n      & + h1".concat(componentCls, ",\n      & + h2").concat(componentCls, ",\n      & + h3").concat(componentCls, ",\n      & + h4").concat(componentCls, ",\n      & + h5").concat(componentCls, "\n      "), {
    marginTop: titleMarginTop
  }), "\n      div,\n      ul,\n      li,\n      p,\n      h1,\n      h2,\n      h3,\n      h4,\n      h5", _defineProperty({}, "\n        + h1,\n        + h2,\n        + h3,\n        + h4,\n        + h5\n        ", {
    marginTop: titleMarginTop
  }))), getResetStyles(token)), getLinkStyles(token)), _defineProperty({}, "\n        ".concat(componentCls, "-expand,\n        ").concat(componentCls, "-collapse,\n        ").concat(componentCls, "-edit,\n        ").concat(componentCls, "-copy\n      "), Object.assign(Object.assign({}, operationUnit(token)), {
    marginInlineStart: token.marginXXS
  }))), getEditableStyles(token)), getCopyableStyles(token)), getEllipsisStyles()), {
    '&-rtl': {
      direction: 'rtl'
    }
  }));
};
export var prepareComponentToken = function prepareComponentToken() {
  return {
    titleMarginTop: '1.2em',
    titleMarginBottom: '0.5em'
  };
};
// ============================== Export ==============================
export default genStyleHooks('Typography', function (token) {
  return [genTypographyStyle(token)];
}, prepareComponentToken);